// conversion tracking code provided by Ontario Reign
export default function (totalCharge, quantity, card) {
  ga("require", "ecommerce");
  gtag("event", "purchase", {
    value: totalCharge,
    currency: "USD",
    quantity,
  });

  fbq("track", "Purchase", { currency: "USD", value: totalCharge });

  // Pinterst pixel code for purchase confirmation
  pintrk("track", "checkout", {
    value: totalCharge,
    order_quantity: 1,
    currency: "USD",
    quantity,
  });

  gtag("event", "conversion", {
    send_to: "AW-755374125/fFKQCODK7aQDEK2wmOgC",
    value: totalCharge,
    currency: "USD",
    transaction_id: card?.id,
  });

  gtag("event", "buy_tickets___fan_rally", {
    send_to: "G-00SKJQX8BZ",
    value: totalCharge, // Replace with the purchase amount
    currency: "USD",
    items: [
      {
        item_name: "test_item_name", // Replace with Product name
        quantity: 1, // Replace with the quantity purchased
        price: totalCharge, // Replace with the price per item
      },
    ],
  });

  // Snap pixel code for purchase confirmation
  (function (e, t, n) {
    if (e.snaptr) return;
    var a = (e.snaptr = function () {
      a.handleRequest
        ? a.handleRequest.apply(a, arguments)
        : a.queue.push(arguments);
    });
    a.queue = [];
    var s = "script";
    r = t.createElement(s);
    r.async = !0;
    r.src = n;
    var u = t.getElementsByTagName(s)[0];
    u.parentNode.insertBefore(r, u);
  })(window, document, "https://sc-static.net/scevent.min.js");

  snaptr("init", "cb2858c9-adf3-4ec7-91e7-d8cbc0184830", {
    user_email: "__INSERT_USER_EMAIL__",
  });

  snaptr("track", "PAGE_VIEW");
  snaptr("track", "PURCHASE", { currency: USD, price: totalCharge, quantity });
}
